import { of as observableOf, Observable, of } from 'rxjs';

import { switchMap, distinctUntilChanged } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { AppSettingsService } from '../../configuracao/services/app-settings.service';
import { ExecutorOperacaoCharonService } from '../../charon/services/executor-operacao-charon-service';
import { MensagensService } from '../../../constantes/mensagens.service';

import { ContaCorrente } from '../models/contaCorrente.model';
import { ConfiguracaoRequisicaoOperacao } from '../../models/configuracao-requisicao-operacao.model';

import { isNullOrUndefined } from '../../../util/is-null-or-undefined.util';
import { SessaoService } from '../../charon/services/sessao.service';

@Injectable()
export class ContaCorrenteService {
  constructor(
    private servicoConfiguracao: AppSettingsService,
    private executorOpServico: ExecutorOperacaoCharonService,
    private sessaoService: SessaoService
  ) {}

  pesquisarConta(filtroConta: Observable<string>) {
    return filtroConta.pipe(
      distinctUntilChanged(),
      switchMap((conta) => this.obterConta(conta))
    );
  }

  /**
   * Recupera dados da conta corrente de um usuário.
   * @param filtroConta Agência, conta e DAC concatenados.
   */
  obterConta(filtroConta: string): Observable<ContaCorrente> {
    if (!isNullOrUndefined(filtroConta)) {
      const configOp = new ConfiguracaoRequisicaoOperacao();
      configOp.metodo = 'GET';
      configOp.nomeOperacao =
        this.servicoConfiguracao.environment.charon.ops.op_movimentacao_dados_complementares_conta;
      configOp.adicionarParametroRota(
        'id_investidor',
        this.sessaoService.obterEbusiness()
      );
      configOp.adicionarParametroRota('id_conta', filtroConta);
      configOp.adicionarCabecalho(
        this.servicoConfiguracao.environment.charon.chave_flowid,
        this.servicoConfiguracao.environment.charon.valor_flowid
      );
      return this.executorOpServico.chamarOperacao<ContaCorrente>(
        configOp,
        (dados: any) => {
          if (dados) {
            return dados;
          } else {
            throw new TypeError(
              MensagensService.mensagens.servicoInvestimento.contaNaoEncontradaDadosBancarios
            );
          }
        },
        (error) => {
          if (error && error.messages && error.messages[0])
            throw new TypeError(error.messages[0].mensagem);
          throw new TypeError(
            MensagensService.mensagens.servicoInvestimento.contaNaoEncontradaDadosBancarios
          );
        }
      );
    } else {
      return observableOf<ContaCorrente>(null);
    }
  }
}
